import { ChangeDetectionStrategy, Component } from '@angular/core';

// Starting with Angular2 RC6, errors are thrown if unknown
// html tags are used.
// In order to get around this, I have created dummy components in order to
// register these custom tags with Angular.
// https://github.com/angular/angular/issues/11251
@Component({
  standalone: true,
  selector: 'fl-display-card-header-left',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayCardHeaderLeftComponent {}
